// Set equal heights for all post teaser headings
var postTeaserHeadings = $('.post-teaser__heading');
var maxPostTeaserHeadingHeight = null;
postTeaserHeadings.each(function(key, item) {
    maxPostTeaserHeadingHeight = $(item).height() > maxPostTeaserHeadingHeight ? $(item).height() : maxPostTeaserHeadingHeight;
});
postTeaserHeadings.each(function(key, item) {
    $(item).css('min-height', maxPostTeaserHeadingHeight + 'px');
});

// var postTeaser = {
//
//     headings: $('.post-teaser__heading'),
//     maxHeadingHeight: 0,
//
//     findMaxHeadingHeight: function() {
//
//         var maxHeight = 0;
//
//         this.headings.each(function(key, item) {
//             maxHeight = $(item).height() > maxHeight ? $(item).height() : maxHeight;
//         });
//
//         this.maxHeadingHeight = maxHeight;
//     },
//
//     setMaxHeadingHeight: function() {
//
//         var maxHeight = this.maxHeadingHeight;
//
//             this.headings.each(function(key, item) {
//             $(item).css('min-height', maxHeight + 'px');
//         });
//     },
//
//     init: function() {
//         this.findMaxHeadingHeight();
//         this.setMaxHeadingHeight();
//     }
// };
//
// postTeaser.init();
